import store from '@/store'
import {
  GET_IS_FIRST_TIME_RECIPIENT,
  GET_REWARD_CUSTOMIZATION,
  GET_REWARD_LINK_EMAIL,
  GET_REWARD_LINK_PLATFORM_IDENTITY_HASH,
  GET_REWARD_LINK_UTID,
  TYPE_OF_REWARD_LINK,
  GET_RL_RECIPIENT_INFO
} from '@/store/get-types'
import { getUserAgentDetails } from '@/helpers/analytics/track-useragent'
import { SegmentClient } from '@/plugins/segment/SegmentClient'

export const createProperties = () => {
  const emailExists = !!store.getters[GET_REWARD_LINK_EMAIL]
  const specificRewardLinkRecipientInfo = store.getters[GET_RL_RECIPIENT_INFO]
  const doesNotAllowRecipientOverride = !store.getters[GET_REWARD_CUSTOMIZATION]?.allowRecipientEmailOverride
  const hasLockedEmail = emailExists && doesNotAllowRecipientOverride
  const userAgentDetails = getUserAgentDetails()
  return {
    first_redemption_occurred_at: specificRewardLinkRecipientInfo?.firstRedemptionOccurredAt,
    is_first_time_recipient: store.getters[GET_IS_FIRST_TIME_RECIPIENT],
    last_redemption_occurred_at: specificRewardLinkRecipientInfo?.lastRedemptionOccurredAt,
    reward_link_utid: store.getters[GET_REWARD_LINK_UTID],
    platform_identity_hash: store.getters[GET_REWARD_LINK_PLATFORM_IDENTITY_HASH],
    reward_link_type: store.getters[TYPE_OF_REWARD_LINK],
    has_locked_email: hasLockedEmail,
    user_agent: userAgentDetails.ua,
    os_name: userAgentDetails.os.name,
    os_version: userAgentDetails.os.version,
    browser_name: userAgentDetails.browser.name,
    browser_version: userAgentDetails.browser.version,
    cpu: userAgentDetails.cpu.architecture,
    device_type: userAgentDetails.device.type,
    device_model: userAgentDetails.device.model,
    device_vendor: userAgentDetails.device.vendor,
    display_width: window.screen.width,
    display_height: window.screen.height,
    total_redemptions: specificRewardLinkRecipientInfo?.totalRedemptions,
    total_redemptions_since_new_recipient_cutoff_date: specificRewardLinkRecipientInfo?.totalRedemptionsSinceNewRecipientCutoff,
    ...segmentOptions.page
  }
}

// For Reward Links only, we need to be careful with sending over sensitive information
// such as the Reward Link Path, which contains a sensitive credential value (the API
// request code). The below also includes other properties that could leak sensitive
// values via Segment.
export const segmentOptions = {
  page: {
    path: null,
    url: null,
    referrer: null
  }
}

export const segmentModule = new SegmentClient(process.env.VUE_APP_SEGMENT_WRITE_KEY, {
  track: createProperties,
  page: createProperties
}, {
  track: segmentOptions,
  page: segmentOptions
})
